import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { ReactElement } from 'react';
import { AnnotationToolType } from '../../../../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { MarkingToolIcon } from '../../../../../__legacy__/modules/annotation/submodules/segmentations/components/objectsList/MarkingToolIcon';
import { S_AnnotationStatus } from '../../../../annotations/annotationStatus/S_AnnotationStatus';
import { IGroundTruth, IPointPrediction } from '../../../jobPredictions.model';

interface ILocatePointsInspectorProps {
  handleTogglePredictionClassId: (classId: string) => () => void;
  predictionClassIds: string[];
  predictedPoints: IPointPrediction[] | null;
  threshold: number;
  groundTruth: IGroundTruth | null | undefined;
}

export const LocatePointsInspector = ({
  predictedPoints,
  handleTogglePredictionClassId,
  predictionClassIds,
  threshold,
  groundTruth,
}: ILocatePointsInspectorProps): ReactElement => {
  const { t } = useTranslator();

  if (!predictedPoints) {
    return <div>{t('no_results_for_current_image')}</div>;
  }

  return (
    <>
      {predictedPoints.map((predictionPoint, idx) => {
        const isVisible = predictionClassIds.includes(predictionPoint.classId);
        return (
          <div
            key={idx}
            className='attributes segmentation clickable'
          >
            <div className='icon-with-name'>
              <div className='marking-tool-icon'>
                <MarkingToolIcon
                  toolType={AnnotationToolType.POINT}
                  color={predictionPoint.color}
                />
              </div>
              <span className='attribute'>
                {predictionPoint.className}:{' '}
                <S_AnnotationStatus
                  text={`${
                    predictionPoint.points.filter((point) => point.score >= threshold).length.toString(10) || '0'
                  }${groundTruth?.predictionCounts?.[predictionPoint.className] ? `/${groundTruth.predictionCounts[predictionPoint.className]}` : ''}`}
                />
              </span>
            </div>
            <div className='object-list-actions'>
              <IconButton
                color={isVisible ? 'primary' : 'neutral'}
                size='sm'
                onClick={handleTogglePredictionClassId(predictionPoint.classId)}
              >
                <FontAwesomeIcon icon={isVisible ? faEye : faEyeSlash} />
              </IconButton>
            </div>
          </div>
        );
      })}
    </>
  );
};
